import { render } from "./SessionTimeoutModal.vue?vue&type=template&id=1be51f1f&ts=true"
import script from "./SessionTimeoutModal.vue?vue&type=script&lang=ts"
export * from "./SessionTimeoutModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__